import React, { Component } from "react";

class ExtensionLocations extends Component {
  render() {
    return (
      <div>
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>Location Name</p>
              </th>
              <th className="table-top-header-left fit-content">
                <p>
                  <span>Min. Version</span>
                </p>
              </th>
              <th className="table-top-header-left">
                <p>
                  <span>Relevant Type</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>

            <tr>
              <td className="table-cell-left" rowSpan="6">
                <p>
                  <span>toolbar</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>access-policy</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Access Policy View , where actions are
                    added as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected Rule Base item (rule or section)</li>
                  <li>Selected layer</li>
                  <li>Selected policy</li>
                </ul>
                <p />
              </td>
            </tr>
            {/* <tr>
              <td className="table-cell-left">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>threat-policy</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Threat Policy View , where extensions are
                    added as aas buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected Rule Base item (rule or exception)</li>
                  <li>Selected layer</li>
                  <li>Selected policy</li>
                </ul>
                <p />
              </td>
            </tr> */}
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>threat-profiles</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Threat Profiles View , where extensions
                    are added as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected profile</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>ips-protections</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the IPS Protections view, where extensions
                    are added as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected protection</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>gateways</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Gateways & Servers view, where extensions
                    are added as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected gateways and servers</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>sessions</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Sessions view, where extensions are added
                    as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected session</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>revisions</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The toolbar in the Revisions view, where extensions are
                    added as buttons that open new windows.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected revision</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left" rowSpan="7">
                <p>
                  <span>details-pane</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>access-policy</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Access Policy View, where extensions
                    are added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected Rule Base item (rule or section)</li>
                  <li>Selected layer</li>
                  <li>Selected policy</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>threat-policy</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Threat Policy View , where extensions
                    are added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected Rule Base item (rule or exception)</li>
                  <li>Selected layer</li>
                  <li>Selected policy</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>threat-profiles</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Threat Profiles view, where
                    extensions are added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected profile</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>ips-protections</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the IPS Protections view, where
                    extensions are added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected protection</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>gateways</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Gateways & Servers view, where
                    extensions are added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected gateways and servers</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>sessions</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Sessions view, where extensions are
                    added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected session</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>revisions</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The bottom pane of the Revisions view, where extensions are
                    added as additional tab pages.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected revision</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>context-menu</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-left">
                <p>
                  <span>gateway</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    The context menu of the selected item in Gateways &amp;
                    Servers view.
                  </span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Selected gateways and servers</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>post-enable-popup</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-inner-header-left">
                <p>
                  <span>extension</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    Popup window post extension enable or installation.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>editor</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-inner-header-left">
                <p>
                  <span>*</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>Topic location in all editors</span>
                </p>
                <p>
                  <span>Relevant objects (retrieved by context):</span>
                </p>
                <p>
                  <span />
                </p>
                <ul>
                  <li>Edited object per editor</li>
                </ul>
                <p />
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>global-pane</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-inner-header-left">
                <p>
                  <span>*</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>The right global pane.</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ExtensionLocations;
